import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const defaultState = {
  connType: ''
}

export const connectionSlice = createSlice({
  name: 'connection',
  initialState: defaultState,
  reducers: {
    setConnType(state, action: PayloadAction<string>) {
      state.connType = action.payload
    }
  }
})

export const { setConnType } = connectionSlice.actions
export { defaultState as connectionDefaultState }
export default connectionSlice.reducer
